import React from 'react';

import {toRunsDataQueryConfig} from '../../containers/RunsDataLoader';
import * as Filter from '../../util/filters';
import * as FilterTypes from '../../util/filterTypes';
import type {PanelSpec} from '../../util/panelTypes';
import {Query} from '../../util/queryTypes';
import * as Run from '../../util/runs';
import * as RunTypes from '../../util/runTypes';
import {MultiRunTableConfig} from './common';
export type {MultiRunTableConfig};

const PANEL_TYPE = 'Multi Run Table';

function transformQuery(query: Query, config: MultiRunTableConfig) {
  const result = toRunsDataQueryConfig(
    query,
    {selectionsAsFilters: true},
    {panelType: PANEL_TYPE}
  );
  const extraFilters: Array<FilterTypes.Filter<RunTypes.Key>> = [];
  result.page = {
    size: 100,
  };
  if (config.tableKey) {
    result.page.size = 20;
    const key = Run.keyFromString(config.tableKey);
    if (key && (key.section === 'config' || key.section === 'summary')) {
      extraFilters.push({key, op: '!=', value: null});
    }
  }
  if (extraFilters.length > 0 && result.runsetQueries.length > 0) {
    result.runsetQueries[0].filters = Filter.And([
      result.runsetQueries[0].filters,
      ...extraFilters,
    ]);
  }
  result.summaryKeys = config.tableKey
    ? [config.tableKey.split(':')[1]]
    : undefined;
  return result;
}

export const Spec: PanelSpec<typeof PANEL_TYPE, MultiRunTableConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
};
